import type { ExperienceSpec } from "@luxidar/experience-schema";
import type { BuilderAsset, PlanResponse } from "./types";

export async function requestPlan(prompt: string, assets: readonly BuilderAsset[], currentSpec?: ExperienceSpec): Promise<PlanResponse> {
  const response = await fetch("/api/plan", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      prompt,
      assets: assets.map(({ id, fileName, type, mediaType }) => ({ id, fileName, type, ...(mediaType ? { mediaType } : {}) })),
      ...(currentSpec ? { currentSpec } : {})
    })
  });
  const body = await response.json().catch(() => ({ success: false, error: { category: "planner", message: "The planner returned an unreadable response." } })) as PlanResponse;
  if (!response.ok && body.success !== false) throw new Error("The planner is temporarily unavailable.");
  return body;
}

export async function requestPackage(spec: ExperienceSpec, assets: readonly BuilderAsset[]): Promise<Blob> {
  const required = new Set(spec.assets.map((asset) => asset.id));
  const selected = assets.filter((asset) => required.has(asset.id));
  const form = new FormData();
  form.set("spec", JSON.stringify(spec));
  form.set("assets", JSON.stringify(selected.map((asset, index) => ({
    id: asset.id,
    fileName: asset.fileName,
    ...(asset.mediaType ? { mediaType: asset.mediaType } : {}),
    field: `asset-${index}`
  }))));
  selected.forEach((asset, index) => form.set(`asset-${index}`, asset.file, asset.fileName));
  const response = await fetch("/api/package", { method: "POST", body: form });
  if (!response.ok) {
    const value = await response.json().catch(() => null) as { error?: { message?: string } } | null;
    throw new Error(value?.error?.message ?? "Package generation failed.");
  }
  return response.blob();
}
